// ======================================================================
// File Name       : InitialImageAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import { commonCallApi } from '../utils/ApiUtils';
import * as httpRequests from './httpRequests/document';
import * as ActionTypes from '../constants/actionTypes/initialImage';
import { DATA_AFFIILIATION_TYPE } from '../constants/ContentConstant';
import { RETURN_MAX_NUM } from '../constants/index';

export function createData(initialImageObject) {
  return {
    type: ActionTypes.INIT_INITIAL_IMAGE,
    initialImageObject,
  };
}

export function getInitialImage(searchInfo) {
  return (dispatch) => {
    commonCallApi({
      path: 'defaultThumbnail/GetList',
      data: searchInfo,
    }).then((result) => {
      dispatch({
        type: ActionTypes.INITIAL_IMAGE_LIST,
        initialImageList: result,
      });
    });
  };
}

export function editInitialImage(auth, listParams) {
  return (dispatch, getState) => {
    if (listParams && listParams.length) {
      const param = listParams[0];
      listParams.splice(0, 1);
      return dispatch(editDefaultThumbnail(param)).then((error) => {
        if (!error) {
          return dispatch(editInitialImage(auth, listParams));
        }
        return error;
      });
    }
    return null;
  };
}

export function editDefaultThumbnail(param) {
  return async (dispatch) => {
    try {
      await commonCallApi({
        path: 'defaultThumbnail/Edit',
        data: param,
        muiltipart: 1,
      });
      return null;
    } catch (error) {
      return error;
    }
  };
}
